import { useRef, useEffect } from "react";
import { ENLARGED_IMAGE_TOP_PADDING, ENLARGED_IMAGE_LEFT_PADDING } from "./constants";
import "./analytic-image.css";

export function AnalyticImage(props) {
  const canvasRef = useRef(null);
  var isAnalyticEnabled = false;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = document.getElementById("base-image");
    const rect = img.getBoundingClientRect();
    const left = Math.max(ENLARGED_IMAGE_LEFT_PADDING, rect.left);
    const top = Math.max(ENLARGED_IMAGE_TOP_PADDING, rect.top);
    canvas.style.left = `${left}px`;
    canvas.style.top = `${top}px`;

    const mouseMoveHandler = (e) => {
      if (!isAnalyticEnabled) {
        return;
      }

      ctx.clearRect(0, 0, props.width, props.height);
      const rect = canvas.getBoundingClientRect();

      ctx.lineWidth = 1;
      ctx.strokeStyle = "#f321ec";
      ctx.beginPath();
      ctx.moveTo(0, e.clientY - top);
      ctx.lineTo(rect.width, e.clientY - top);
      ctx.stroke();

      ctx.lineWidth = 1;
      ctx.strokeStyle = "#f321ec";
      ctx.beginPath();
      ctx.moveTo(e.clientX - left, 0);
      ctx.lineTo(e.clientX - left, rect.height);
      ctx.stroke();
    };

    const mouseOutHandler = () => {
      ctx.clearRect(0, 0, props.width, props.height);
    };

    const clickHandler = (e) => {
      isAnalyticEnabled = !isAnalyticEnabled;
      if (isAnalyticEnabled) {
        mouseMoveHandler(e);
      } else {
        mouseOutHandler();
      }
    };

    canvas.addEventListener("click", clickHandler);
    canvas.addEventListener("mousemove", mouseMoveHandler);
    canvas.addEventListener("mouseout", mouseOutHandler);

    return () => {
      canvas.removeEventListener("click", clickHandler);
      canvas.removeEventListener("mousemove", mouseMoveHandler);
      canvas.removeEventListener("mouseout", mouseOutHandler);
    };
  }, []);

  return (
    <div>
      <img id="base-image" width={props.width} height={props.height} src={props.src} />
      <canvas
        id={props.id}
        className="analytic-canvas"
        ref={canvasRef}
        width={props.width}
        height={props.height}
      />
    </div>
  );
}
